import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Box, Paper } from "@mui/material";
import { useSelector } from "react-redux";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import { quotationTableHeader } from "../../../components/datagrid/myworkspace/hr/quotations/quotationTableHeader";
import AddOrUpdateQuotation from "./AddOrUpdateQuotation";
import { getQuotationRequirements } from "../../../redux/features/assetManagementSlice";
import ActionDetails from "../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../components/mui/GlobalAnchor/GlobalAnchorList";
import ViewQuotationsOfRequirements from "./ViewQuotationsOfRequirements";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";

const QuotationsView = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search, rowData } = paginationData;

  const { loading, resData, quotationsData } = useSelector(
    (store) => store.assetmanagement
  );
  const { data, meta } = resData;

  const dispatchParams = {
    paginationData,
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getQuotationRequirements(dispatchParams));
    }
  }, [gridSize, pageNum, search]);

  return (
    <GlobalWrapper
      title={"Quotations"}
      actions={
        meta?.isEditable && (
          <AddOrUpdateQuotation dispatchParams={dispatchParams} />
        )
      }
    >
      <Box sx={{ mt: 1 }}>
        <Paper>
          <GlobalDatagrid
            tableHead={quotationTableHeader}
            rows={data}
            meta={meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={true}
            actionComponent={
              <>
                <ActionDetails val={rowData?.product_name} />
                <GlobalAnchorList
                  label="Action"
                  component={
                    <ViewQuotationsOfRequirements
                      dispatchParams={dispatchParams}
                      row={rowData}
                      isApproval={!meta?.isApproval}
                      isEditable={!meta?.isEditable}
                      productName={rowData?.product_name}
                    />
                  }
                />
                <GlobalAnchorList
                  component={
                    <AddOrUpdateQuotation
                      dispatchParams={dispatchParams}
                      isEditable={!meta?.isEditable}
                      row={rowData}
                      quotationsData={quotationsData}
                    />
                  }
                />
              </>
            }
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default QuotationsView;
